import { type Object3D } from 'three'
import creaseGeometryNormalsForTraverse from './creaseGeometryNormalsForTraverse'

export default function creaseGeometryNormalsRecursive(
  obj: Object3D,
): void {
  creaseGeometryNormalsForTraverse(obj)
  obj.traverse(creaseGeometryNormalsForTraverse)
}
